import App, { PqApp } from "../app";
import { ContextShownEvent, ToggleContextsEvent } from "../events";
import Controller from "./controller";
import { AttemptId, ProductId, ItemId, QuizId } from "../model/datasource";

export class ContextController<P extends ProductId, A extends AttemptId, Z extends QuizId, I extends ItemId> extends Controller<P, A, Z, I> {
	bind(target: EventTarget, app: PqApp<P, A, Z, I>): void {
		target.addEventListener(ToggleContextsEvent.type, (event: ToggleContextsEvent) => this.toggleContexts(app, event.detail));
		target.addEventListener(ContextShownEvent.type, (event: ContextShownEvent) => this.contextShown(app, event.detail));
	}

	toggleContexts(app: PqApp<P, A, Z, I>, contexts: string[]): void {
		app.view.item.toggleContexts(contexts);
	}

	contextShown(app: PqApp<P, A, Z, I>, id: string): void {
		app.timer.viewContext(app.current.get(), id);
	}
}